<div class="write-main"
role="dialog"
aria-modal="true"
aria-labelledby="writeDialogTitle">
  <!-- <img class="close-icon cursor-pointer" (click)="closePopUp()" src="assets/icons/close_black_round.png"> -->
   <button
    type="button"
    class="close-btn"
    aria-label="Close dialog"
    (click)="closePopUp()">

    <img
        src="assets/icons/close_black_round.png"
        class="close-icon"
        alt="">

</button>
  <!-- <div class="pop-up-heading">
    Write to Us
  </div> -->
  <h2
    id="writeDialogTitle"
    class="pop-up-heading">

    Write to Us

</h2>
  <div class="pop-up-info">
    Please fill the details below and we will get in touch with you
  </div>
  <!-- <form (ngSubmit)="f.form.valid && processForm()" #f="ngForm" novalidate> -->
  <form
  #f="ngForm"
  novalidate
  (ngSubmit)="onSubmit(f)">
   <div class="instructions">Fields with 
    <span class="mandatory"> * </span> 
    are mandatory
    </div>
                <div class="instructions">
                    Your personal details will be used only for the purpose of communicating with you and will not be
                    shared with a third party.
                </div>
    <div class="col-lg-12 row">

      <div class="col-lg-6">
        <label class="lbl-text" for="firstName">First Name <span class="mandatory"> *</span></label><br>
        <input id="firstName" type="text" [pattern]="alphaPattern" minlength="1" maxlength="32" [(ngModel)]="firstName"
          autocomplete="given-name" name="first" #name="ngModel" required [attr.aria-invalid]="f.submitted && name.invalid"
          aria-describedby="firstNameError">
        <div *ngIf="f.submitted && name.invalid" id="firstNameError" class="error-text" role="alert">
          <div *ngIf="name.errors?.['required']">First name is required</div>
          <div *ngIf="name.errors?.['pattern']">First name not valid.</div>
        </div>
      </div>
      <div class="col-lg-6">
        <label class="lbl-text" for="lastName">Last Name <span class="mandatory"> *</span></label><br>
        <input id="lastName" type="text" [pattern]="alphaPattern" minlength="1" maxlength="32" [(ngModel)]="lastName"
          autocomplete="family-name" name="last" #lname="ngModel" required [attr.aria-invalid]="f.submitted && lname.invalid"
          aria-describedby="lastNameError">
        <div *ngIf="f.submitted && lname.invalid" id="lastNameError" class="error-text" role="alert">
          <div *ngIf="lname.errors?.['required']">Last name is required</div>
          <div *ngIf="lname.errors?.['pattern']">First name not valid.</div>
        </div>
      </div>
      <div class="col-lg-6">
        <label class="lbl-text" for="mobile">Mobile <span class="mandatory"> *</span></label><br>
        <input type="text" class="mobText" minlength="10" maxlength="10" [pattern]="mobNumberPattern" id="mobile"
          [(ngModel)]="userData.mobileNumber" autocomplete="tel" name="mobile" #mobile="ngModel" required [attr.aria-invalid]="f.submitted && mobile.invalid"
          aria-describedby="mobileError">
        <div *ngIf="f.submitted && mobile.invalid" id="mobileError" class="error-text" role="alert">
          <div *ngIf="f.submitted && mobile.errors?.['required']">Mobile number required</div>
          <div *ngIf="mobile.errors?.['pattern']">Mobile number not valid.</div>
        </div>
      </div>
      <div class="col-lg-6">
        <label class="lbl-text" for="email">Email <span class="mandatory"> *</span></label><br>
        <input id="email" type="text" minlength="5" maxlength="64" [(ngModel)]="userData.emailId" autocomplete="email" name="email"
          #email="ngModel" required email [attr.aria-invalid]="f.submitted && email.invalid"
          aria-describedby="emailError">
        <div *ngIf="f.submitted && email.invalid" id="emailError" class="error-text" role="alert">
          <div *ngIf="email.errors?.['required']">Email required</div>
          <div *ngIf="email.errors?.['email']">Enter a valid email address</div>
        </div>
      </div>
      <div class="col-lg-6">
        <label class="lbl-text" for="city">City <span class="mandatory"> *</span></label><br>
        <select id="city" [(ngModel)]="userData.city" #city="ngModel" name="city" autocomplete="address-level2" required [attr.aria-invalid]="f.submitted && city.invalid"
         aria-describedby="cityError">
          <option value="">Select your city</option>
          <option *ngFor="let item of cityList" [value]="item.cityName">{{item.cityName | titlecase}}</option>
        </select>
        <!-- <span class="mandatory" *ngIf="city.invalid && city.errors?.['required']">City required</span> -->
         <div
          *ngIf="f.submitted && city.invalid"
          id="cityError"
          class="error-text"
          role="alert">

          <div *ngIf="city.errors?.['required']">
            City required
          </div>

        </div>
      </div>
      <div class="col-lg-6">
        <label class="lbl-text" for="reason">Reason <span class="mandatory"> *</span></label><br>
        <select id="reason" [(ngModel)]="userData.reason" name="reason" #reason="ngModel" required [attr.aria-invalid]="f.submitted && reason.invalid"
         aria-describedby="reasonError">
          <option value="">Select</option> 
          <option *ngFor="let item of reasonList" [value]="item">{{item}}</option>
        </select>
        <div *ngIf="f.submitted && reason.invalid" id="reasonError" class="error-text" role="alert">
          <div *ngIf="reason.errors?.['required']">Reason required</div>
        </div>
      </div>
      <div class="col-lg-12">
        <label class="lbl-text" for="message">Message </label><br>
        <mat-label>(Maximum 100 characters)</mat-label>
        <textarea id="message" rows="1" [pattern]="msgPattern" maxlength="100" name="message"
          #message="ngModel" [(ngModel)]="userData.message" [attr.aria-invalid]="f.submitted && message.invalid"
          aria-describedby="messageError"></textarea>
        <div *ngIf="f.submitted && message.invalid" id="messageError" class="error-text" role="alert">
          <div *ngIf="message.errors?.['pattern']">Invalid message.</div>
        </div>
      </div>
      <div class="col-lg-12">
        <button class="submit-button btn-spc">Submit</button>
        
      </div>
    </div>
  </form>
</div>